import { Box, IconNew, ModBox, SpacerNew, TextNew } from '@jfs/ui-new'
import { useState } from 'react';
import { Linking } from 'react-native'
import { DROPDOWN_ARROW, HORIZONTAL, ITERATOR, SPACER_CONSTANT } from '../AccordionConstants'
import { toggleAccordion } from '../AccordionFunction'
import { style } from './style'

const AccordionItem = ({ data, index, totalDataLength, isMobile }: any) => {
  const [selectedIndex, setSelectedIndex] = useState(ITERATOR)
  const isParagraph = data?.isParagraph ?? false
  const isExpanded = index === selectedIndex
  const isLastIndex = totalDataLength === index + 1
  const isFirstIndex = index === 0
  const styleMetaData = style(isExpanded, isLastIndex, isFirstIndex, isMobile)
  return (
    <Box
      {...styleMetaData.accordionView}
      onPress={() => toggleAccordion(index, selectedIndex, setSelectedIndex, ITERATOR)}>
      <Box {...styleMetaData.titleContainer}>
        <Box w={'85%'}>
          <TextNew {...styleMetaData.titleText} title={data?.title} />
        </Box>
        <IconNew id={isExpanded ? 'ARROW_UP' : 'ARROW_DOWN'} color={'BLUE'} size={DROPDOWN_ARROW} />
      </Box>
      {isExpanded && <SpacerNew size={SPACER_CONSTANT} />}
      <ModBox show={isExpanded && !isParagraph}>
        {!isParagraph &&
          data?.subheading?.map((item: any) => (
            <Box {...styleMetaData.subtitleContainer}>
              <ModBox {...styleMetaData.roundBulletin} />
              <SpacerNew direction={HORIZONTAL} size={SPACER_CONSTANT} />
              <TextNew {...styleMetaData.subtitle} title={item?.text} />
            </Box>
          ))}
      </ModBox>
      <ModBox show={isExpanded && isParagraph}>
        <ModBox flexDirection="row" flexWrap="wrap" w={isMobile ? '99%' : '80%'} ml={-4}>
          {data?.subheading?.split(' ').map((detail: string, subInd: number) => {
            const isLink = detail.includes('https://')
            const isEmail = detail.includes('@')
            const newStyle = isLink || isEmail ? styleMetaData.emailPhone : styleMetaData.subtitle
            return isEmail || isLink ? (
              <ModBox
                flexDirection="row"
                key={subInd}
                zIndex={999}
                onPress={() => (isLink ? Linking.openURL(detail) : Linking.openURL(`mailto:${detail}`))}
                underlayColor={'TRANSPARENT'}>
                <TextNew {...newStyle}>{` ${detail}`}</TextNew>
              </ModBox>
            ) : (
              <TextNew key={subInd} {...newStyle}>{` ${detail}`}</TextNew>
            )
          })}
        </ModBox>
      </ModBox>
    </Box>
  )
}

export { AccordionItem }
